import { API } from '@/shared/api/modules';
import type { GetBedHistoryRequestDto } from '@/shared/api/modules/floor-plan';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getBedHistoryQueryOptions = (params: GetBedHistoryRequestDto) =>
  queryOptions({
    queryKey: ['bed-history', params],
    queryFn: () => API.floorPlan.getBedHistory(params),
    placeholderData: keepPreviousData,
    enabled: params.floorPlanId > 0,
  });
